import { closestCenter, DndContext, PointerSensor, useSensor, useSensors } from "@dnd-kit/core";
import { arrayMove, SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { List, Paper, Typography } from "@mui/material";
import SortableRow from "./SortableRow";

export default function SortOrderList({ items, onReorder, onRemove, changedIds }) {
    const sensors = useSensors(useSensor(PointerSensor, { activationConstraint: { distance: 5 } }));

    const handleDragEnd = (event) => {
        const { active, over } = event;
        if (!over || active.id === over.id) return;

        const oldIndex = items.findIndex((item) => item.id === active.id);
        const newIndex = items.findIndex((item) => item.id === over.id);
        onReorder(arrayMove(items, oldIndex, newIndex), active.id);
    };

    if (!items.length) {
        return (
            <Paper variant="outlined" sx={{ p: 4, textAlign: "center" }}>
                <Typography color="text.secondary">
                    No products in the sort order yet. Search and add products above.
                </Typography>
            </Paper>
        );
    }

    return (
        <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
            <SortableContext items={items.map((item) => item.id)} strategy={verticalListSortingStrategy}>
                <Paper variant="outlined">
                    <List disablePadding>
                        {items.map((item, index) => (
                            <SortableRow
                                key={item.id}
                                id={item.id}
                                index={index + 1}
                                name={item.name}
                                onRemove={onRemove}
                                isChanged={changedIds?.has(item.id)}
                            />
                        ))}
                    </List>
                </Paper>
            </SortableContext>
        </DndContext>
    );
}
